export default __webpack_public_path__ + "static/media/dollarNftCircle.9e109fdd.svg";